import React from 'react';
import { BaseCalendarProps, CalendarEvent } from './types';
import { EventChip } from './EventChip';

export interface DayViewProps extends BaseCalendarProps {
  day?: Date;
}

function startOfDay(date: Date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

function endOfDay(date: Date) {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
}

function eventsForDay(events: CalendarEvent[] | undefined, day: Date) {
  if (!events) return [] as CalendarEvent[];
  return events.filter((e) => e.start <= endOfDay(day) && e.end >= startOfDay(day)).sort((a, b) => a.start.getTime() - b.start.getTime());
}

export const DayView: React.FC<DayViewProps> = ({ day = new Date(), events, onEventClick }) => {
  const items = eventsForDay(events, day);
  return (
    <div className="bg-white border rounded-lg">
      <div className="p-3 border-b">
        <h3 className="text-sm font-semibold">
          {day.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' })}
        </h3>
      </div>
      <div className="p-2 space-y-2">
        {items.length === 0 && (
          <div className="text-sm text-muted-foreground">No events</div>
        )}
        {items.map((ev) => (
          <EventChip key={ev.id} event={ev} onClick={onEventClick} />
        ))}
      </div>
    </div>
  );
};


